<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" :class="[`${prefix}-icon`, `${prefix}-icon-upload`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_f4b4514bbe__a"><rect width="16" height="16" rx="0"/></clipPath></defs><g clip-path="url(#svg_f4b4514bbe__a)"><path d="M13.2998,5.412L10.09374,5.412C10.00519,5.41256,9.93327,5.34418,9.93385,5.26L9.93385,2.214C9.93385,2.0789999999999997,10.10636,2.01,10.20734,2.106L13.4134,5.153C13.5144,5.248,13.4418,5.412,13.2998,5.412ZM14.2686,4.35L10.96258,1.180002C10.83068,1.0638878,10.65743,0.999573884,10.47767,1.00000215292L2.215268,1.00000215292C1.820236,1.00000210815,1.5,1.304448,1.5,1.680002L1.5,14.32C1.5,14.696,1.821871,15,2.215268,15L6.7446,15L6.7446,12.017L4.580909999999999,12.017C4.37054,11.816,4.37054,11.49,4.580909999999999,11.287L7.64289,8.093C7.85344,7.89177,8.196,7.89177,8.40655,8.093L11.47168,11.287C11.6831,11.488,11.6831,11.814,11.47168,12.017L9.30905,12.017L9.30905,15L13.7847,15C14.1798,15,14.5,14.6956,14.5,14.32L14.5,4.85C14.5001,4.65956,14.4161,4.47783,14.2686,4.349" :fill="useCurrentColor ? 'currentColor' : '#387EFA'"/></g></svg>
</template>
<script>

export default {
  name: 'IconUpload',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
